import React from 'react';
import {
	CardButton,
	CardLogo,
	CardLogoWrapper,
	CardTextWrapper,
	CardTimer,
	CardTitle,
	CardWrapper,
	RightImage,
	Time
} from 'pages/landing/cards/styled';
import pnp_2_bg from 'assets/img/landing/cards/pnp_2_bg.jpg';
import pnp from 'assets/img/landing/cards/pnp.svg';
import { Timer } from 'components/Timer';
import man from 'assets/img/landing/cards/man.png';
import { useSelector } from 'react-redux';
import { getUpComingContestEvent } from 'modules/selectors';
import { HOCisTrue } from 'components/HOCisTrue';
import { EnumEventStatus } from 'apps/BWW_PLAY_HUB/modules/utils';
import moment from 'moment';
import bet_mgm_logo from 'apps/BWW_PLAY_HUB/assets/img/bet_mgm.png';

export const UpcomingContest: React.FC = () => {
	const event = useSelector(getUpComingContestEvent);
	const isBettingAllowed = true;
	const isEventCompleted = event?.status === EnumEventStatus.Complete;
	const isEventLive = event?.status === EnumEventStatus.Active;
	const isEventScheduled = event?.status === EnumEventStatus.Scheduled;

	const isEventCompletedClass = () => {
		return isEventCompleted ? 'completed' : '';
	}

	const isEventLiveClass = () => {
		return isEventLive ? 'live' : '';
	}

	if (!event) {
		return null;
	}

	return (
		<CardTextWrapper>
			<h3>Upcoming contest</h3>
			<CardWrapper image={pnp_2_bg}>
				<CardLogoWrapper spbtw={isBettingAllowed}>
					<CardLogo src={pnp} alt="UpNext"/>
					<HOCisTrue when={isBettingAllowed}>
						<img src={bet_mgm_logo} alt="bet logo"/>
					</HOCisTrue>
				</CardLogoWrapper>
				<CardTitle>
					{event.name}
					<span> 100 BLAZIN’ REWARD POINTS</span>
				</CardTitle>
				<CardTimer>
					<HOCisTrue when={isEventScheduled}>
						<Timer
							key={'upNext'}
							format="hh:mm:ss"
							separator={':'}
							date={new Date(event?.start || '').getTime()}
							as={Time}
						/>
					</HOCisTrue>
				</CardTimer>
				<CardButton className={`${isEventCompletedClass()} ${isEventLiveClass()}`}>
					<HOCisTrue when={isEventLive}>
						Live
					</HOCisTrue>
					<HOCisTrue when={isEventCompleted}>
						Completed
					</HOCisTrue>
					<HOCisTrue when={isEventScheduled}>
						Play now
					</HOCisTrue>
				</CardButton>
				<RightImage src={man} alt="man"/>
			</CardWrapper>
			<HOCisTrue when={isEventScheduled}>
				<h4>{moment(event?.start ).format('Do MMM YYYY')}</h4>
			</HOCisTrue>
		</CardTextWrapper>
	);
}
